export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export class UnauthorizedError extends ApiError {
  constructor(message = 'unauthorized') {
    super(401, message);
    this.name = 'UnauthorizedError';
  }
}

export class RateLimitError extends ApiError {
  constructor(message = 'rate limited') {
    super(429, message);
    this.name = 'RateLimitError';
  }
}

export class ValidationError extends ApiError {
  constructor(message = 'invalid request') {
    super(400, message);
    this.name = 'ValidationError';
  }
}
